import { useContext } from 'react';
import axios from 'axios';
import { useMediaQuery } from '@dnhb/node_package';
import { Stack } from '../../shared/layouts';
import { checkAndFormatDates } from '../../../utils/dateHelpers';
import MessagebarContext from '../../../context/MessagebarContext';
import CapitalCard from './CapitalCard';
import Loader from '../../shared/Loader';
import { useQuery } from 'react-query';
import { useTheme } from '@emotion/react';
import Header from '../../shared/Header';
import Placeholder from '../../shared/Placeholder';
import { useTranslation } from 'react-i18next';
import useIconLibrary from "../../../hooks/useIconLibrary";

const CapitalPage = () => {
  const { setAlertMessage } = useContext(MessagebarContext);
  const { breakpoints } = useTheme();
  const isMinDesktop = useMediaQuery(
    `(min-width: ${breakpoints.ml ?? '56.25rem'})`
  );
  const { t } = useTranslation();
  const { CurrencyIcon } = useIconLibrary();

  const { isLoading, data: { capital = [] } = {} } = useQuery(
    'dossier',
    async () =>
      await axios
        .get('/dossier/data')
        .then(({ data }) => checkAndFormatDates(data))
        .catch(() => setAlertMessage())
  );

  return (
    <Stack space="xl" width={{ sm: 656, ml: 672, lg: 800, xl: 1024 }}>
      {isLoading && <Loader />}
      <Header
        title={t('Vermogen')}
        icon={
          isMinDesktop ? <CurrencyIcon height="2rem" width="2rem" /> : null
        }
        variant="page"
      />
      {capital.length > 0 ? (
        capital.map((capitalProduct, index) => (
          <CapitalCard
            key={`capital-${index}`}
            index={index}
            capital={capitalProduct}
            isMinDesktop={isMinDesktop}
          />
        ))
      ) : (
        <Placeholder>{t('Geen vermogen gevonden')}</Placeholder>
      )}
    </Stack>
  );
};

export default CapitalPage;
